<template>
    <SecondaryAction @click="compose()" icon="sr-2 sr-v2-paper-airplane" text="Message" />
</template>

<script>
import SecondaryAction from '@/components/Navbar/SecondaryAction'
import { mapGetters } from 'vuex'

export default {
    components: { SecondaryAction },

    props: {
        breakpoint: { type: String }
    },

    computed: {
        ...mapGetters('athleteProfile', ['athleteId']),
        ...mapGetters('userData', ['isUsingProfileKey']),

        composeUrl() {
            return `/messages/compose?athlete=${this.athleteId}`
        },

        shouldOpenInNewTab() {
            return !this.isUsingProfileKey
        },
    },

    methods: {
        compose() {
            if (this.shouldOpenInNewTab) {
                window.open(this.composeUrl, '_blank')
            } else {
                window.location.href = this.composeUrl
            }
        }
    }
}
</script>